import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  GcRadioButtonComponent,
  GcTextComponent,
} from '@ip-only/front-end-library';
import { RadioButtonInputData } from '../../report-input-entities';
import { OptionsButtonComponent } from '../options-button/options-button.component';

@Component({
  selector: 'app-radio-button-input',
  imports: [GcRadioButtonComponent, GcTextComponent, OptionsButtonComponent],
  templateUrl: './radio-button-input.component.html',
  styleUrl: './radio-button-input.component.scss',
})
export class RadioButtonInputComponent {
  @Input() data: RadioButtonInputData;
  @Input() optionsButton? = true;
  @Output() checkedValue = new EventEmitter<string>();
}
